import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactFCV } from '@types';

import { messages } from '../../messages';

import { GiftPackagingIcon } from './GiftPackagingIcon';
import { StyledGrid, StyledTitle, StyledDescription } from './styled';

export const GiftPackagingUnavailable: ReactFCV = () => (
  <StyledGrid>
    <GiftPackagingIcon />
    <StyledTitle>
      <FormattedMessage {...messages.giftPackagingUnavailableTitle} />
    </StyledTitle>
    <StyledDescription>
      <FormattedMessage {...messages.giftPackagingUnavailableDescription} />
    </StyledDescription>
  </StyledGrid>
);
